var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CDirectionsButton',{staticClass:"hidden-print directions-button",attrs:{"size":_vm.size,"shadow":null,"label":_vm.label,"link":("https://www.google.com/maps/dir/?api=1&destination=" + _vm.lat + "," + _vm.lon)}})}
var staticRenderFns = []

export { render, staticRenderFns }